var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-method moyasar-applepay"},[_c('div',{staticClass:"moyasar-applepay-header"},[_c('div',{staticClass:"left"},[_c('AppleIcon')],1),_c('span',{staticClass:"center"},[_vm._v(_vm._s(_vm.$t("m.applePay")))])]),_c('div',{key:_vm.formKey,ref:"moyasarApplePayForm",staticClass:"mysr-form"})])
}
var staticRenderFns = []

export { render, staticRenderFns }